let urlParams = new URLSearchParams(window.location.search);

let min = 1000000;
let max = 99000000000;
let eventId = Math.floor(Math.random() * (max - min + 1)) + min;

setCookie('fbEventId', eventId, 1);

window.sizePresets = [
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 14.5 Collar - 32 Sleeve",
    "Fit": "Slim Fit",
    "Size": "14.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 14.5 Collar - 33 Sleeve",
    "Fit": "Slim Fit",
    "Size": "14.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 15 Collar - 32 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 15 Collar - 33 Sleeve",
    "Fit": "Slim Fit",
    "Size": 15,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 15 Collar - 34 Sleeve",
    "Fit": "Slim Fit",
    "Size": 15,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 15 Collar - 35 Sleeve",
    "Fit": "Slim Fit",
    "Size": 15,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 15.5 Collar - 32 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 15.5 Collar - 33 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 15.5 Collar - 34 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 15.5 Collar - 35 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 15.5 Collar - 36 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 15.5 Collar - 37 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Long"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 16 Collar - 32 Sleeve",
    "Fit": "Slim Fit",
    "Size": 16,
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 16 Collar - 33 Sleeve",
    "Fit": "Slim Fit",
    "Size": 16,
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 16 Collar - 34 Sleeve",
    "Fit": "Slim Fit",
    "Size": 16,
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 16 Collar - 35 Sleeve",
    "Fit": "Slim Fit",
    "Size": 16,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 16 Collar - 36 Sleeve",
    "Fit": "Slim Fit",
    "Size": 16,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 16 Collar - 38 Sleeve",
    "Fit": "Slim Fit",
    "Size": 16,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 16.5 Collar - 33 Sleeve",
    "Fit": "Slim Fit",
    "Size": "16.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 16.5 Collar - 34 Sleeve",
    "Fit": "Slim Fit",
    "Size": "16.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 16.5 Collar - 35 Sleeve",
    "Fit": "Slim Fit",
    "Size": "16.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 16.5 Collar - 36 Sleeve",
    "Fit": "Slim Fit",
    "Size": "16.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 16.5 Collar - 38 Sleeve",
    "Fit": "Slim Fit",
    "Size": "16.5",
    "Length": "Long"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 17 Collar - 34 Sleeve",
    "Fit": "Slim Fit",
    "Size": 17,
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 17 Collar - 35 Sleeve",
    "Fit": "Slim Fit",
    "Size": 17,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 17 Collar - 36 Sleeve",
    "Fit": "Slim Fit",
    "Size": 17,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 17 Collar - 37 Sleeve",
    "Fit": "Slim Fit",
    "Size": 17,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 17 Collar - 38 Sleeve",
    "Fit": "Slim Fit",
    "Size": 17,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 17.5 Collar - 34 Sleeve",
    "Fit": "Slim Fit",
    "Size": "17.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 17.5 Collar - 35 Sleeve",
    "Fit": "Slim Fit",
    "Size": "17.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 17.5 Collar - 36 Sleeve",
    "Fit": "Slim Fit",
    "Size": "17.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Slim Fit - 17.5 Collar - 38 Sleeve",
    "Fit": "Slim Fit",
    "Size": "17.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 15 Collar - 32 Sleeve",
    "Fit": "Slim Fit",
    "Size": "14.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 15 Collar - 33 Sleeve",
    "Fit": "Slim Fit",
    "Size": "14.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 15 Collar - 34 Sleeve",
    "Fit": "Slim Fit",
    "Size": "14.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 15 Collar - 35 Sleeve",
    "Fit": "Slim Fit",
    "Size": "14.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 15.5 Collar - 32 Sleeve",
    "Fit": "Slim Fit",
    "Size": 15,
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 15.5 Collar - 33 Sleeve",
    "Fit": "Slim Fit",
    "Size": 15,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 15.5 Collar - 34 Sleeve",
    "Fit": "Slim Fit",
    "Size": 15,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 15.5 Collar - 35 Sleeve",
    "Fit": "Slim Fit",
    "Size": 15,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 15.5 Collar - 36 Sleeve",
    "Fit": "Slim Fit",
    "Size": 15,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 15.5 Collar - 37 Sleeve",
    "Fit": "Slim Fit",
    "Size": 15,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 16 Collar - 32 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 16 Collar - 33 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 16 Collar - 34 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 16 Collar - 35 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 16 Collar - 36 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 16 Collar - 38 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Long"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 16.5 Collar - 33 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.75",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 16.5 Collar - 34 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.75",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 16.5 Collar - 35 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.75",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 16.5 Collar - 36 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.75",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 16.5 Collar - 38 Sleeve",
    "Fit": "Slim Fit",
    "Size": "15.75",
    "Length": "Long"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 17 Collar - 33 Sleeve",
    "Fit": "Slim Fit",
    "Size": "16.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 17 Collar - 34 Sleeve",
    "Fit": "Slim Fit",
    "Size": "16.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 17 Collar - 35 Sleeve",
    "Fit": "Slim Fit",
    "Size": "16.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 17 Collar - 36 Sleeve",
    "Fit": "Slim Fit",
    "Size": "16.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 17 Collar - 37 Sleeve",
    "Fit": "Slim Fit",
    "Size": "16.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 17.5 Collar - 34 Sleeve",
    "Fit": "Slim Fit",
    "Size": 17,
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 17.5 Collar - 35 Sleeve",
    "Fit": "Slim Fit",
    "Size": 17,
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Extra Slim Fit - 17.5 Collar - 36 Sleeve",
    "Fit": "Slim Fit",
    "Size": 17,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 15 Collar - 32 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "14.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 15 Collar - 33 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "14.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 15 Collar - 34 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "14.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 15.5 Collar - 32 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 15.5 Collar - 33 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 15.5 Collar - 34 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 15.5 Collar - 35 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 15.5 Collar - 36 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 16 Collar - 33 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.75",
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 16 Collar - 34 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.75",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 16 Collar - 35 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.75",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 16 Collar - 36 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.75",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 16.5 Collar - 33 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Short"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 16.5 Collar - 34 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 16.5 Collar - 35 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 16.5 Collar - 36 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 17 Collar - 35 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "16.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Charles Tyrwhitt - Super Slim Fit - 17 Collar - 37 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "16.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Slim Fit - 14.5 Collar - 33.5 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 15,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Slim Fit - 15 Collar - 33 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.75",
    "Length": "Short"
  },
  {
    "Shirt to choose": "TM Lewin - Slim Fit - 15 Collar - 34 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.75",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Slim Fit - 15.5 Collar - 33 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Short"
  },
  {
    "Shirt to choose": "TM Lewin - Slim Fit - 15.5 Collar - 34.5 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Slim Fit - 15.5 Collar - 36 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Slim Fit - 16 Collar - 33 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "16.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "TM Lewin - Slim Fit - 16 Collar - 35 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "16.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Slim Fit - 16 Collar - 36 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "16.5",
    "Length": "Long"
  },
  {
    "Shirt to choose": "TM Lewin - Slim Fit - 16.5 Collar - 33 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 17,
    "Length": "Short"
  },
  {
    "Shirt to choose": "TM Lewin - Slim Fit - 16.5 Collar - 34.5 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 17,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Slim Fit - 16.5 Collar - 36 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 17,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Slim Fit - 16.5 Collar - 38 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 17,
    "Length": "Long"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 14.5 Collar - 33.5 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "14.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 15 Collar - 33 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 15 Collar - 34 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 15.5 Collar - 33 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.75",
    "Length": "Short"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 15.5 Collar - 34.5 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.75",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 15.5 Collar - 36 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "15.75",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 16 Collar - 33 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Short"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 16 Collar - 35 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 16 Collar - 36 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Long"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 16.5 Collar - 33 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "16.5",
    "Length": "Short"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 16.5 Collar - 34.5 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "16.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 16.5 Collar - 36 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "16.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 16.5 Collar - 38 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": "16.5",
    "Length": "Long"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 17 Collar - 34.5 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 17,
    "Length": "Short"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 17 Collar - 36 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 17,
    "Length": "Short"
  },
  {
    "Shirt to choose": "TM Lewin - Fitted Fit - 17 Collar - 38 Sleeve",
    "Fit": "Extra Slim Fit",
    "Size": 17,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 13.5 - Regular",
    "Fit": "Slim Fit",
    "Size": "14.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 14 - Regular",
    "Fit": "Slim Fit",
    "Size": "14.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 14.5 - Regular",
    "Fit": "Slim Fit",
    "Size": 15,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 14.5 - Long",
    "Fit": "Slim Fit",
    "Size": 15,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 15 - Regular",
    "Fit": "Slim Fit",
    "Size": 15,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 15 - Long",
    "Fit": "Slim Fit",
    "Size": 15,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 15.5 - Regular",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 15.5 - Long",
    "Fit": "Slim Fit",
    "Size": "15.5",
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 15.75 - Regular",
    "Fit": "Slim Fit",
    "Size": "15.75",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 15.75 - Long",
    "Fit": "Slim Fit",
    "Size": "15.75",
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 16 - Regular",
    "Fit": "Slim Fit",
    "Size": 16,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 16 - Long",
    "Fit": "Slim Fit",
    "Size": 16,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 16.5 - Regular",
    "Fit": "Slim Fit",
    "Size": 16,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 16.5 - Long",
    "Fit": "Slim Fit",
    "Size": 16,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 17 - Regular",
    "Fit": "Slim Fit",
    "Size": 17,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 17 - Long",
    "Fit": "Slim Fit",
    "Size": 17,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 17.5 - Regular",
    "Fit": "Slim Fit",
    "Size": 17,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Slim Fit - 17.5 - Long",
    "Fit": "Slim Fit",
    "Size": 17,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 13.5 - Regular",
    "Fit": "Extra Slim Fit",
    "Size": 15,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 14 - Regular",
    "Fit": "Extra Slim Fit",
    "Size": 15,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 14.5 - Regular",
    "Fit": "Extra Slim Fit",
    "Size": "15.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 14.5 - Long",
    "Fit": "Extra Slim Fit",
    "Size": "15.5",
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 15 - Regular",
    "Fit": "Extra Slim Fit",
    "Size": "15.75",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 15 - Long",
    "Fit": "Extra Slim Fit",
    "Size": "15.75",
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 15.5 - Regular",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 15.5 - Long",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 15.75 - Regular",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 15.75 - Long",
    "Fit": "Extra Slim Fit",
    "Size": 16,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 16 - Regular",
    "Fit": "Extra Slim Fit",
    "Size": "16.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 16 - Long",
    "Fit": "Extra Slim Fit",
    "Size": "16.5",
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 16.5 - Regular",
    "Fit": "Extra Slim Fit",
    "Size": 17,
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 16.5 - Long",
    "Fit": "Extra Slim Fit",
    "Size": 17,
    "Length": "Long"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 17 - Regular",
    "Fit": "Extra Slim Fit",
    "Size": "17.5",
    "Length": "Regular"
  },
  {
    "Shirt to choose": "Suitsupply - Tailored Fit - 17 - Long",
    "Fit": "Extra Slim Fit",
    "Size": "17.5",
    "Length": "Long"
  }
];


if ($('#sizePresets').length) {

const selectElement = document.getElementById('sizePresets');
   window.sizePresets.forEach(shirt => {
            const option = document.createElement('option');
            option.value = JSON.stringify(shirt);
            option.text = `${shirt["Shirt to choose"]}`;
            selectElement.appendChild(option);
    });

  $("select#sizePresets").select2({
    minimumResultsForSearch: -1,
      placeholder: "Make a selection",
});


  $('#sizePresets').on('change', function() {

    if ($(this).val()) {
    let selectedValue = JSON.parse($(this).val());
 
    $('variant-radios input[name="Length"][value="' + selectedValue.Length + '"]').trigger('click');
    $('variant-radios input[name="Size"][value="' + selectedValue.Size + '"]').trigger('click');
    $('variant-radios input[name="Fit"][value="' + selectedValue.Fit + '"]').trigger('click');
   
    }
    
  });
  
}




function image_banner_fullheight() {
  if ($(".banner--full").length > 0) {
    var announcementHeight = 0;
    if ($("#shopify-section-announcement-bar").length > 0) {
      announcementHeight = $("#shopify-section-announcement-bar").height();
    }
    $(".banner--full").css({
      height:
        $(window).height() -
        $("#shopify-section-header").height() -
        announcementHeight,
    });
  }
}

function setCookie(cname, cvalue, exdays, url = "/") {
  console.log('Setting ' + cvalue);
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=" + url;
}



function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

async function resolveUserId(email = false, token = false) {

  var resolveId = {
    "url": "https://api.editsuits.com/store/customer/resolveUserId",
    "method": "POST",
    "timeout": 0,
    "data": { shopifyId: $("#customerShopifyId").val(), email: $('#customerEmail').val() }
  };

  const response = await fetch(resolveId.url, {
      method: resolveId.method,
      body: JSON.stringify(resolveId.data),
      headers: {
        "Content-Type": "application/json",
      },
    });

  let json = await response.json();
  let id = json.id;

  return {
    id: id,
  token: token};
  
}


$(document).ready(function () {
  $("[data-youtube], [data-vbg]").youtube_background();
  image_banner_fullheight();


  
  $('.BtdShopifyContentArea').append('<div class="cannotfind">Can\'t find the answer to your question - contact us <a href="/pages/contact">here</a></div>');
  
});

$(window).resize(function () {
  image_banner_fullheight();
});

$(".premium-suiting--content .content").on("click", function () {
  if ($(window).width() < 769) {
    let text = $(this).html();
    $(".premium_description").html(text);
  }
});

$(".product-info--accordion-item-title").on("click", function () {
  if ($(this).closest(".product-info--accordion-item").hasClass("active")) {
    $(this).closest(".product-info--accordion-item").removeClass("active");
    $(this)
      .closest(".product-info--accordion-item")
      .children(".product-info--accordion-item-content")
      .slideUp();
  } else {
    $(this)
      .closest(".product-info--accordion-item")
      .addClass("active")
      .find(".product-info--accordion-item-content")
      .slideDown();
  }
});

$(".input--clear_search_field").on("click", function () {
  $(".search__input.field__input").val("").change();
});

$(".page_back").on("click", function (e) {
  e.preventDefault();
  let page = getCookie("prevpage");
  window.location = page;
});

// open style details by default

if (!$('.product-info--accordion').hasClass('collapsed')) {
  $(".product-info--accordion-item").addClass("active");
  $(".product-info--accordion-item-content").slideDown();
}


$(document).on("click", ".cart-notification__close", function () {
  $("#cart-notification").removeClass("active");
  // setTimeout(window.location.reload(), 1000);
});

// read more section

$(".readMoreButton").on("click", function (e) {
  e.preventDefault();
  if ($(this).text() === "Read more") {
    $(this).parent().find("span.hide").addClass("shown").show();
    $(this).text('Read less');
  } else {
    $(this).parent().find("span.hide").removeClass("shown").hide();
    $(this).text('Read more');
  }
});



$(async function () {

  /* getting customer measurement status */

  
  if ($("#customerToken").length && $("#customerToken").val().length > 2) {

    let id = await resolveUserId();
    id = id.id;
    
    if (localStorage.getItem("customer_measurements") === null) {
    
      var settings = {
        url:
          "https://orders.editsuits.com/api/customers/" +
          id +
          "/editable_categories",
        method: "GET",
        timeout: 0,
        headers: {
          token: "bd0ceb613c5a41a0be91623183ddfb5c",
          Authorization: "Bearer bd0ceb613c5a41a0be91623183ddfb5c",
          "Content-Type": "text/plain",
        },
        data: "",
      };

      $.ajax(settings).done(function (response) {
        let editableCategories = [];
        var sizesGrid = $(".sizes_grid");
        for (const [key, value] of Object.entries(
          response.editable_categories
        )) {
          if (value === "YES" || value === "NO") {
            editableCategories.push(key);
          }
        }

        if (editableCategories.length > 0) {
          localStorage.setItem(
            "customer_measurements",
            JSON.stringify(editableCategories)
          );
        } else {
          localStorage.setItem(
            "customer_measurements",
            'none'
          );
        }
      });
    }
  } else {
    localStorage.removeItem("customer_measurements");
  }

  // document.addEventListener(
  //   "touchmove",
  //   (event) => event.scale !== 1 && event.preventDefault(),
  //   { passive: false }
  // );

  // country specific blocks

  // if (window.location.pathname.includes("en-sg")) {
  //   $('div[data-country="gb"]').closest("section").hide();
  // } else {
  //   $('div[data-country="sg"]').closest("section").hide();
  // }
});



